import { bullfrogVersion } from '@/version'

// Process-constant attributes every MusicMetrix action carries (GH's SDK-level
// `appVersion` / `deviceTimeZone`), resolved once for every metric family.

export const metricAppVersion: string = bullfrogVersion.str

// GH emits deviceTimeZone as a ±HH:MM UTC offset; getTimezoneOffset returns
// minutes BEHIND UTC (positive west of UTC), so the sign is inverted.
function utcOffsetLabel(offsetMinutes: number): string {
    const sign = offsetMinutes <= 0 ? '+' : '-'
    const hours = Math.floor(Math.abs(offsetMinutes) / 60)
    const minutes = Math.abs(offsetMinutes) % 60
    return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}

export const metricDeviceTimeZone: string = utcOffsetLabel(new Date().getTimezoneOffset())
